
import { takeLatest, put } from 'redux-saga/effects';
import { COMMON_ERROR, FETCH_FILE_BYTES, LOGIN_ERROR } from '../../../shared/constants/commonConstants';
import { FetchFileByteRequest, FetchFileByteResponse } from '../../../shared/models/file.profile.model';
import { FetchCalendarEventsRequest, FetchCalendarResponse, HospitalProfileRequest, HospitalProfileResponse } from '../../../shared/models/hospitalProfile.model';
import { SearchLookUpResponse } from '../../../shared/models/lookUp.model';
import ApplicationDetail from '../../../shared/services/applicationDetail.service';
import SendRequest from '../../../shared/services/sendRequest.service';
import { logout } from '../../actions/authAction';
import {
  fetchCalendarEvents, fetchIPDepartmentMasterData, fetchHospitalProfileData,
  hospitalLogo, infraImages, fetchIPInclusionMasterData, fetchDayCareDepartmentMasterData,
  fetchDayCareInclusionMasterData, fetchAmenityMasterData, setPatientSearchDetail, setHospitalPatientSearchDetails, setHISDoctorList,
  setHISCardDisplayParameters,
} from '../../actions/hospitalAction';
import actionTypes from '../../types/hospitalTypes';
import {
  DEPARTMENT_INPATIENT, FETCH_CALENDAR, INCLUSION_TYPE_INPATIENT, PROFILE_FETCHPROFILEDETAILS,
  DEPARTMENT_DAYCARE, INCLUSION_TYPE_DAYCARE, FETCH_AMENITY_LIST,
} from '../../../shared/constants/urlEndPoints';
import { centeredNotification, error } from '../../../utils/utility';
import { setNewEntry } from '../../actions/hospitalAction';
import {decryptText} from '../../../utils/encryptDecrypt';
import { GLOBAL_URL } from '../../../shared/constants/dataServiceUrl';
import { baseUrl } from '../../../shared/constants/crmConstants';
function* hospitalProfileSaga({ payload }: any): Generator {
  const { data, onSuccess } = payload;
  const {
    fetchContactDetail, fetchBankDetail, fetchRoom, idFromSso,
    fetchRegistrationDetail, fetchCalendar, providerDetails = {},
  } = data ? data : {} as any;

  const provider: any =
    providerDetails
      ? providerDetails
      : JSON.parse(decryptText(localStorage.getItem('providerDetail') || '{}') as any);

  const payloadRequest: HospitalProfileRequest = {
    applicationId: 1234,
    pageNumber: 0,
    pageSize: 0,
    profileById: Number(provider?.providerId) > 0 ? false : true,
    profileBySupremeId: Number(provider?.providerId) > 0 ? true : false,
    approvalType: 'BOTH',
    fetchInActiveRecord: false,
    fetchProperty: true,
    fetchContactDetail: fetchContactDetail ? fetchContactDetail : true,
    fetchBankDetail: fetchBankDetail ? fetchBankDetail : false,
    fetchRoom: fetchRoom ? fetchRoom : false,
    fetchDocumentDetail: true,
    fetchRegistrationDetail: fetchRegistrationDetail ? fetchRegistrationDetail : false,
    isMaskAccountAndPAN: true,
    fetchCalendar: fetchCalendar ? fetchCalendar : false,
    profileIds: payload && idFromSso ? [+idFromSso] : [+ApplicationDetail.instance.getProfileId()],
    // profileBySupremeId: false,
    supremeIds: [provider && provider.providerId ? provider.providerId : '0'],
  };
  const saveUrl = `${process.env.REACT_APP_BASE_URL}${PROFILE_FETCHPROFILEDETAILS}`;
  try {
    const response: any = yield SendRequest.instance.post<HospitalProfileRequest,
      HospitalProfileResponse>(saveUrl, payloadRequest);
    if (response && response.isSuccess && response.profileDetails) {
      yield put(fetchHospitalProfileData(response.profileDetails));
      yield put(setNewEntry(false));
      onSuccess(response.profileDetails);
    } else {
      yield put(setNewEntry(true));
      if (payload && payload.idFromSso) {
        error(LOGIN_ERROR);
        yield put(logout());
        window.location.href = '/';
      }
    }
    return;
  } catch (e) {
    yield put(logout());
  }
}

function* fetchCalendarSaga({ payload: { payload, getApiResponse } }: any): Generator {
  const url = `${process.env.REACT_APP_BASE_URL}${FETCH_CALENDAR}`;
  try {
    const response: any = yield SendRequest.instance.post<FetchCalendarEventsRequest,
      FetchCalendarResponse>(url, payload);
    if (response && response.isSuccess && response.calendarEvent) {
      getApiResponse(true);
      yield put(fetchCalendarEvents(response.calendarEvent));
    } else {
      yield put(fetchCalendarEvents([null]));
      getApiResponse(false);
    }
    return;
  } catch (e) {
    error('Error occured while fetching calendar events, please try again.');
  }
}

function* fetchLogoSaga({ payload }: any): Generator {
    const url = `${process.env.REACT_APP_BASE_URL}${FETCH_FILE_BYTES}`;
    try {
      const response: any = yield SendRequest.instance.post<FetchFileByteRequest,
        FetchFileByteResponse>(url, payload);
      if (response && response.isSuccess && response.fileDetails && response.fileDetails.length > 0) {
        yield put(hospitalLogo(response.fileDetails[0]));
      }
      return;
    } catch (e) {
      error('Error occured, please try again.');
    }
}

function* fetchInfraImagesSaga({ payload }: any): Generator {
  const url = `${process.env.REACT_APP_BASE_URL}${FETCH_FILE_BYTES}`;
  try {
    const response: any = yield SendRequest.instance.post<FetchFileByteRequest,
      FetchFileByteResponse>(url, payload);
    if (response && response.isSuccess && response.fileDetails && response.fileDetails.length > 0) {
      yield put(infraImages(response.fileDetails));
    } else {
      error('Infrastructure images not found, please upload image.');
    }
    return;
  } catch (e) {
    error('Error occured, please try again.');
  }
}

function* fetchIPInclusionMasterSaga(): Generator {
  const url = `${process.env.REACT_APP_INVENTORY_API_BASE_URL}${INCLUSION_TYPE_INPATIENT}`;
  try {
    const response: any = yield SendRequest.instance.get<
      SearchLookUpResponse>(url);
    if (response && response.isSuccess && response.lookUpData && response.lookUpData.length > 0) {
      yield put(fetchIPInclusionMasterData(response.lookUpData));
    } else {
      error('Inclusion master not found.');
    }
    return;
  } catch (e) {
    error('Error occured, please try again.');
  }
}
function* fetchIPDepartmentMasterSaga(): Generator {

  const url = `${process.env.REACT_APP_INVENTORY_API_BASE_URL}${DEPARTMENT_INPATIENT}`;
  try {
    const response: any = yield SendRequest.instance.get<
      SearchLookUpResponse>(url);
    if (response && response.isSuccess && response.lookUpData && response.lookUpData.length > 0) {
      yield put(fetchIPDepartmentMasterData(response.lookUpData));
    } else {
      error('Departments not found.');
    }
    return;
  } catch (e) {
    error('Error occured, please try again.');
  }
}
function* fetchDayCareDepartmentMasterSaga(): Generator {

  const url = `${process.env.REACT_APP_INVENTORY_API_BASE_URL}${DEPARTMENT_DAYCARE}`;
  try {
    const response: any = yield SendRequest.instance.get<
      SearchLookUpResponse>(url);
    if (response && response.isSuccess && response.lookUpData && response.lookUpData.length > 0) {
      yield put(fetchDayCareDepartmentMasterData(response.lookUpData));
    } else {
      error('Departments not found.');
    }
    return;
  } catch (e) {
    error('Error occured, please try again.');
  }
}
function* fetchDayCareInclusionMasterSaga(): Generator {
  const url = `${process.env.REACT_APP_INVENTORY_API_BASE_URL}${INCLUSION_TYPE_DAYCARE}`;
  try {
    const response: any = yield SendRequest.instance.get<
      SearchLookUpResponse>(url);
    if (response && response.isSuccess && response.lookUpData && response.lookUpData.length > 0) {
      yield put(fetchDayCareInclusionMasterData(response.lookUpData));
    } else {
      error('Inclusion master not found.');
    }
    return;
  } catch (e) {
    error('Error occured, please try again.');
  }
}
function* fetchAmenityMasterSaga(): Generator {
  const url = `${process.env.REACT_APP_BASE_URL}${FETCH_AMENITY_LIST}`;
  try {
    const response: any = yield SendRequest.instance.get<
      SearchLookUpResponse>(url);
    if (response && response.isSuccess && response.lookUpData && response.lookUpData.length > 0) {
      yield put(fetchAmenityMasterData(response.lookUpData));
    } else {
      error('Amenity master not found.');
    }
    return;
  } catch (e) {
    error('Error occured, please try again.');
  }
}

/*
function to fetch a patient's details from the HIS
response only contains 1 object,
condition to check whether it is an array is because MAX uses the same function and that returns a array of objects
*/
function* getPatientVisitDetails({payload }: any): Generator {
  const {onSuccess, onError, payload: formData, isVisitsEnabled} = payload;
  if (formData?.mobileNo) {
    formData.mobileNo = formData?.mobileNo?.split(' ')?.slice(1)?.join('');
  }
  const url = `${GLOBAL_URL.CRM_BASE_URL}IntegrationSystem/VisitDetails/${formData?.visitCode}`;
  const sendRequest = SendRequest.instance;
  try {
    const HISResponse: any = yield sendRequest.post<any, any>(url, (formData));
    const { isSuccess, integrationSystemSearchResponseDTO, hospitalData, errorMessage, displayParameters } = HISResponse;
    if (!isVisitsEnabled) {
      yield put(setHospitalPatientSearchDetails([]));
      yield put(setHISCardDisplayParameters([]));
    }
    yield put(setPatientSearchDetail([]));
    let patientHISDetails: any = [];
    if (isSuccess) {
      if (integrationSystemSearchResponseDTO) {
        patientHISDetails = integrationSystemSearchResponseDTO;
        yield put(setHospitalPatientSearchDetails(patientHISDetails));
        onSuccess();
      } else if (hospitalData) {
        if (!isVisitsEnabled) {
          yield put(setHospitalPatientSearchDetails(hospitalData));
          if ( displayParameters ) {
            yield put(setHISCardDisplayParameters(displayParameters));
          }
          onSuccess();
        } else {
          onSuccess(hospitalData?.[0]);
        }
      }
    } else {
      onError(errorMessage);
    }
    return;
    // never enters the catch block because CRM always sends 200 even in case of an error but with an error message
  } catch (e: any) {
    onError('Unable to fetch patient details from HIS. Retry or proceed without info');
  }
}

// function to get all the visits details of the patient
function* getPatientAllVisitsDetails({payload}: any): Generator {
  const {onSuccess, onError, payload: formData} = payload;
  if (formData?.mobileNo) {
    formData.mobileNo = formData?.mobileNo?.split(' ')?.slice(1)?.join('');
  }
  const url = `${GLOBAL_URL.CRM_BASE_URL}IntegrationSystem/VisitDetails`;
  const sendRequest = SendRequest.instance;
  try {
    const HISResponse: any = yield sendRequest.post<any, any>(url, (formData));
    const {isSuccess, hospitalData, errorMessage, displayParameters} = HISResponse;
    yield put(setHospitalPatientSearchDetails([]));
    yield put(setPatientSearchDetail([]));
    yield put(setHISCardDisplayParameters([]));
    if (isSuccess && hospitalData) {
        yield put(setHospitalPatientSearchDetails(hospitalData));
        if ( displayParameters ) {
          yield put(setHISCardDisplayParameters(displayParameters));
        }
        onSuccess();
    } else {
      yield put(setHospitalPatientSearchDetails([]));
      onError(errorMessage);
    }
    return;
    // never enters the catch block because CRM always sends 200 even in case of an error but with an error message
  } catch (e: any) {
    onError('Unable to fetch patient details from HIS. Retry or proceed without info');
  }
}

function* getHISDoctorsList({payload}: any): Generator {
  const url = `${GLOBAL_URL.CRM_BASE_URL}IntegrationSystem/GetMAXHealthcareDoctorList`;
  const sendRequest = SendRequest.instance;
  try {
      const response: any  = yield sendRequest.post(url, payload);
      const {isSuccess, doctors} = response;
      if (isSuccess) {
        const doctorListDataHIS = doctors.map((doctor: any): any => ({ // format doctors list
          value: doctor.doctorId,
          name: doctor.doctorName,
          registraionNo: undefined,
    }));
        yield put(setHISDoctorList(doctorListDataHIS));
      }
      return;
    } catch (e) {
  }
}

export function* getTickerData({ payload: { providerId, onSuccess, onError } }: any): Generator {
  const isVersioningPostAPIEnabled = ApplicationDetail?.instance?.getIsVersioningPostAPIEnabled(); // Checking the flag

  try {
    const sendRequest = SendRequest.instance;
    let response: any;
    const url = `${baseUrl}/Provider/GetTickerConfigurations`;
    if (isVersioningPostAPIEnabled) {
      response = yield sendRequest.post(url, {});
    } else {
      response = yield sendRequest.get(`${url}?providerId=${providerId}`);
    }
    const { tickerConfigurations } = response || {};
    onSuccess(tickerConfigurations);
  } catch (response: any) {
    const { errors, ErrorMessage }: any = response || {};
    if (errors instanceof Array) {
      onError(errors?.join(',') || ErrorMessage);
    } else {
      onError(COMMON_ERROR);
    }
  }
}

export function* updateHospitalSeal({ payload: { fileGuid, propertyName } }: any): Generator {
  const url = `${GLOBAL_URL.CRM_BASE_URL}/Provider/AddOrUpdateEntityProperty`;
  const sendRequest = SendRequest.instance;
  const request = {
    fileGuid,
    propertyName,
  };
  try {

    const response: any = yield sendRequest.post(url, request);
    const { isSuccess, errorMessage } = response;
    if (isSuccess) {
      centeredNotification(`${propertyName} is Updated`, 'success');
    } else {
      centeredNotification(errorMessage);
    }
    return;
  } catch (e) {
    centeredNotification('Error occured, please try again.');
  }
}

export function* watchHospitalAction(): any {
  yield takeLatest(actionTypes.FETCH_CALENDAR, fetchCalendarSaga);
  yield takeLatest(actionTypes.HOSPITAL_PROFILE, hospitalProfileSaga);
  yield takeLatest(actionTypes.FETCH_HOSPITAL_LOGO, fetchLogoSaga);
  yield takeLatest(actionTypes.FETCH_INFRA_IMAGES, fetchInfraImagesSaga);
  yield takeLatest(actionTypes.FETCH_IP_INCLUSION_MASTER, fetchIPInclusionMasterSaga);
  yield takeLatest(actionTypes.FETCH_IP_DEPARTMENT_MASTER, fetchIPDepartmentMasterSaga);
  yield takeLatest(actionTypes.FETCH_DAYCARE_DEPARTMENT_MASTER, fetchDayCareDepartmentMasterSaga);
  yield takeLatest(actionTypes.FETCH_DAYCARE_INCLUSION_MASTER, fetchDayCareInclusionMasterSaga);
  yield takeLatest(actionTypes.FETCH_AMENITY_MASTER, fetchAmenityMasterSaga);
  yield takeLatest(actionTypes.GET_HIS_DOCTORS_LIST, getHISDoctorsList);
  yield takeLatest(actionTypes.GET_PATIENT_VISIT_DETAILS, getPatientVisitDetails);
  yield takeLatest(actionTypes.GET_PATIENT_ALL_VISITS_DETAILS, getPatientAllVisitsDetails);
  yield takeLatest(actionTypes.GET_TICKER_CONFIGURATION, getTickerData);
  yield takeLatest(actionTypes.UPDATE_HOSPITAL_SEAL, updateHospitalSeal);
}

export default watchHospitalAction;
